import { render, staticRenderFns } from "./panel-picture-settings.vue?vue&type=template&id=c4202264&scoped=true&"
import script from "./panel-picture-settings.vue?vue&type=script&lang=js&"
export * from "./panel-picture-settings.vue?vue&type=script&lang=js&"
import style0 from "./panel-picture-settings.vue?vue&type=style&index=0&id=c4202264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4202264",
  null
  
)

export default component.exports